module.exports = __webpack_public_path__ + "img/bgr-tickling-stars.f23d5100.svg";